import type { IGrid } from './index'
import type { RootState } from '..'

import { createSelector } from 'reselect'

export const getApp = (state: RootState) => state.grid

export const selectData = createSelector(getApp, (app: IGrid) => {
  return app.data
})
export const selectStatus = createSelector(getApp, (app: IGrid) => {
  return app.isLoaded
})

export const selectStatusClaim = createSelector(getApp, (app: IGrid) => {
  return app.isLoadedClaim
})
export const selectStatusZelis = createSelector(getApp, (app: IGrid) => {
  return app.isLoadedZelis
})
export const selectCountRow = createSelector(getApp, (app: IGrid) => {
  return app.count
})
export const selectDataRow = createSelector(getApp, (app: IGrid) => {
  return app.dataRow
})
export const selectDataCountRow = createSelector(getApp, (app: IGrid) => {
  return app.countRow
})
export const selectStatuses = createSelector(getApp, (app: IGrid) => {
  return app.statuses
})
export const selectStatusMapping = createSelector(getApp, (app: IGrid) => {
  return app.statusMapping
})
export const selectPendingAvoid = createSelector(getApp, (app: IGrid) => {
  return app.avoidPending
})
export const selectDataZelis = createSelector(getApp, (app: IGrid) => {
  return app.dataZelis
})
export const selectNotification = createSelector(getApp, (app: IGrid) => {
  return app.notification
})
